export default __webpack_public_path__ + "static/media/nav-background.d06f9f96.svg";